import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight, Sparkles, Target, Activity, CircleDot, Crown, Swords, Dumbbell,
  Shield, Zap, TrendingUp, Goal, Volleyball, Waves, Heart,
} from "lucide-react";
import PageHeader from "../components/site/PageHeader";
import { api } from "../lib/api";

const ICONS = {
  Target, Activity, CircleDot, Crown, Swords, Dumbbell, Shield, Zap,
  TrendingUp, Goal, Volleyball, Waves, Heart, Sparkles,
};

export default function Branches() {
  const [branches, setBranches] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/branches").then((r) => setBranches(r.data)).catch(() => {});
  }, []);

  const filtered = useMemo(() => {
    if (filter === "active") return branches.filter((b) => b.is_active);
    if (filter === "soon") return branches.filter((b) => !b.is_active);
    return branches;
  }, [branches, filter]);

  return (
    <div data-testid="branches-page">
      <PageHeader
        eyebrow="Spor Branşları"
        title="20+ Branşlı Kulüp Yapısı"
        subtitle="Çocuklar, gençler ve yetişkinler için geniş bir branş yelpazesi. Aktif olanlara kayıt ol, yakında açılacak olanlar için bizi takip et veya antrenör olarak başvur."
      />

      <section className="section-pad">
        <div className="container-x">
          <div className="flex flex-wrap items-center gap-2 mb-8" data-testid="branch-filters">
            {[
              { k: "all", label: "Tümü" },
              { k: "active", label: "Aktif" },
              { k: "soon", label: "Yakında" },
            ].map((b) => (
              <button
                key={b.k}
                type="button"
                onClick={() => setFilter(b.k)}
                data-testid={`filter-${b.k}`}
                className={`rounded-full border px-4 py-2 font-display text-xs font-bold uppercase tracking-wider transition-all ${
                  filter === b.k
                    ? "bg-primary text-primary-foreground border-primary"
                    : "border-border bg-secondary hover:border-primary hover:text-primary"
                }`}
              >
                {b.label}
              </button>
            ))}
            <span className="ml-auto text-xs font-display uppercase tracking-wider text-muted-foreground">
              {filtered.length} Branş
            </span>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {filtered.map((b) => {
              const Icon = ICONS[b.icon] || Sparkles;
              return (
                <Link
                  key={b.slug}
                  to={`/branslar/${b.slug}`}
                  className="card-elev p-6 group block"
                  data-testid={`branch-${b.slug}`}
                >
                  <div className="flex items-start justify-between mb-5">
                    <div className="h-12 w-12 rounded-md bg-primary/10 ring-1 ring-primary/20 flex items-center justify-center text-primary">
                      <Icon className="h-6 w-6" />
                    </div>
                    {b.is_active ? (
                      <span className="badge-status-active"><span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />Aktif</span>
                    ) : (
                      <span className="badge-status-soon"><span className="h-1.5 w-1.5 rounded-full bg-primary" />Yakında</span>
                    )}
                  </div>
                  <h3 className="font-display text-2xl font-bold uppercase tracking-tight mb-2 group-hover:text-primary transition-colors">
                    {b.name}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{b.short_description}</p>
                  <div className="mt-5 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-primary">
                    Detay <ArrowRight className="h-3 w-3" />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
